import { TicketTypeProps } from './types';

export const sortTicketTypes = (ticketTypes: TicketTypeProps[]) => {
	return ticketTypes.sort((a, b) => {
		if (a.orderIndex < b.orderIndex) return -1;
		if (a.orderIndex > b.orderIndex) return 1;
		return a.iD - b.iD;
	});
};
